/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Admin_Billing_Pile_OneInputs */



/**
* | output |
* | --- |
* | "1 closed report · {amount} uninvoiced" |
*
* @param {Partner_Admin_Billing_Pile_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_pile_one = /** @type {((inputs: Partner_Admin_Billing_Pile_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Pile_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`1 abgeschlossener Bericht · ${i?.amount} nicht abgerechnet`)
	return /** @type {LocalizedString} */ (`1 closed report · ${i?.amount} uninvoiced`)
});